<template>
	<div class="job-active-filter">
		<header v-if="hasFilterValues">
			<div>Aktive Filter</div>
			<div>
				<a href="#" @click.prevent="$emit('resetFilterValues')">
					<Icon icon="bin"/>
					Alle entfernen
				</a>
			</div>
		</header>
		<div class="job-active-filter--groups">
			<div
				v-for="item in filterValuesGroupedByRow"
				:key="item.row.id"
				class="job-active-filter--group"
			>
				<div class="job-active-filter--group-title">{{ item.row.label }}</div>
				<ul v-for="value in item.values">
					<li>
						<span>{{ value.label }}</span>
						<span>
							<a href="#" @click.prevent="$emit('removeFilterValue', value)">
								<Icon icon="bin" />
							</a>
						</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import _ from "lodash";
import Icon from "@/vue/icon/Icon";

export default {

	components: {
		Icon,
	},

	props: {
		filterValues: {
			type: Array,
			required: false,
		}
	},

	computed: {
		hasFilterValues ()
		{
			return this.filterValues && this.filterValues.length > 0;
		},
		filterValuesGroupedByRow ()
		{
			let grouped = {};

			_.forEach(this.filterValues, filterValue =>
			{
				const row = filterValue.row;

				if (!grouped[row.id])
				{
					grouped[row.id] = {
						row,
						values: []
					};
				}

				grouped[row.id].values.push(filterValue);
			});

			return grouped;
		}
	},
}
</script>
